module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_home_residential-db3de993084a29e9b88a315cbbf02004.png";